import { z } from "zod";
import { ZodDateString } from "../zod-types/zod-date-string";
import { ZodStringNullable } from "../zod-types/zod-string-nullable";

export const ticketWorkExclusionSchema = z.object({
	/** The one day the work cannot happen on. A break is a day, never a span. */
	date: ZodDateString,
	/**
	 * Why. Optional, because a break put in from the bar is a click and has nowhere to type — the
	 * modal is where a reason is given, and the gap in the bar says the same thing either way.
	 */
	note: ZodStringNullable,
});

export type TicketWorkExclusionFormSchema = z.infer<typeof ticketWorkExclusionSchema>;
